import { z } from 'zod'
import { propagatedFailureSchema } from '../utils/error-failure.js'

const legacyFailureSchema = z.object({
  error_code: z.string().min(1),
  error_category: z.enum(['rejected', 'unexpected', 'cancelled']).optional(),
  error_message: z.string().min(1).optional(),
})

/** Read old stored events and queued/journaled batches without keeping legacy fields in new writes. */
export function normalizeLegacySystemEventFailureData(
  data: Record<string, unknown>,
): Record<string, unknown> {
  if (!('error_code' in data)) {
    return data
  }
  const legacy = legacyFailureSchema.safeParse(data)
  if (!legacy.success) {
    return data
  }
  const { error_code: _code, error_category: _category, error_message: _message, ...rest } = data
  if (data.failure === undefined) {
    return {
      ...rest,
      failure: {
        message: legacy.data.error_message ?? '',
        ...(legacy.data.error_category === 'cancelled' ? { isCancelled: true } : {}),
      },
    }
  }
  // Old feeds displayed error_message, while failure.message could contain raw library text.
  // Validate first so overriding the display text cannot hide malformed failure data.
  const failure = propagatedFailureSchema.safeParse(data.failure)
  return {
    ...rest,
    failure: failure.success
      ? { ...failure.data, message: legacy.data.error_message ?? failure.data.message }
      : data.failure,
  }
}
